import financial from "../financial"
import studentAccountList from "../items/student_account_list"
import journalList from "../items/account_journal_list"
import studentCashList from "../items/student_cash_list"
import cashJournalList from "../items/cash_journal_list"
import cashRechargeList from "../items/cash_recharge_list"
import courseRechargeList from "../items/course_recharge_list"
import performanceList from "../items/performance_list"
import tradeFlowList from "../items/trade_flow_list"
import couponList from "../items/coupon_list"
import studentCouponList from "../items/student_coupon_list"
import courseAccountIndex from "../items/course_account_index"
import cashAccountIndex from "../items/cash_account_index"
import approvedRecordList from "../items/approved_record_list.vue"
import coursePriceList from "../items/course_price_list.vue"
import FinancialAccess from "../../../components/FinancialAccess.vue"

// A scoped slot delays mounting (and data requests) until the server grants access.
const guarded = (component, permission) => ({
	render(h) {
		return h(FinancialAccess, { props: { permission }, scopedSlots: { default: () => h(component) } })
	}
})

export default {
	path:'financial',
	name:'financial',
	component:financial,
	children:[
		{
			path:'student/account/list',
			name:'student-account-list',
			component:guarded(studentAccountList, 'courseAccount')
		},
		{
			path:'student/account/journal/list',
			name:'student-account-journal-list',
			component:guarded(journalList, 'courseJournal')
		},
		{
			path:'student/cash/list',
			name:'student-cash-list',
			component:studentCashList
		},
		{
			path:'student/cash/journal/list',
			name:'student-cash-journal-list',
			component:cashJournalList
		},
		{
			path:'student/cash/recharge/list',
			name:'student-cash-recharge-list',
			component:cashRechargeList
		},
		{
			path:'student/course/recharge/list',
			name:'student-course-recharge-list',
			component:guarded(courseRechargeList, 'courseRecharge')
		},
		{
			path:'performance/list',
			name:'performance-list',
			component:performanceList
		},
		{
			path:'trade/flow/list',
			name:'trade-flow-list',
			component:guarded(tradeFlowList, 'tradeFlow')
		},
		{
			path:'coupon/list',
			name:'coupon-list',
			component:couponList
		},
		{
			path:'student/coupon/list',
			name:'student-coupon-list',
			component:studentCouponList
		},
		{
			path:'course/account/index',
			name:'course-account-index',
			component:guarded(courseAccountIndex, 'courseAccount')
		},
		{
			path:'cash/account/index',
			name:'cash-account-index',
			component:cashAccountIndex
		},
		{
			path:'approved/record/list',
			name:'approved-record-list',
			component:approvedRecordList
		},
		{
			path:'course/price/list',
			name:'course-price-list',
			component:coursePriceList
		}
	]
}
